
import { CONSTANTS } from "../../constants";
import { getDate, readingTime } from "../../lib/utils";
import { getCollections } from "../../services";

export default {
  async asyncData({ params, redirect }) {
    try {
      const resp = await getCollections(
        `${CONSTANTS.BLOG_API_ENDPOINT}/api/posts/${params.slug}?populate=author.avatar,tags,coverImage,category`,
        CONSTANTS.BLOG_API_KEY
      );

      if (!resp) redirect(404, "/error");

      const { attributes } = resp;
      const tags = attributes?.tags.data.map(
        (tag) => tag.attributes.name || []
      );
      const imageUrl =
        attributes?.coverImage.data?.attributes.formats.medium?.url ||
        attributes?.coverImage.data?.attributes?.url;
      const article = {
        slug: attributes.slug,
        image: `${CONSTANTS.BLOG_API_ENDPOINT}${imageUrl}`,
        category: attributes.category.data.attributes.name,
        tags,
        title: attributes.title,
        snippet: attributes.description,
        author: {
          name: attributes.author.data?.attributes?.name,
          image: `${CONSTANTS.BLOG_API_ENDPOINT}${attributes.author.data?.attributes?.avatar?.data?.attributes?.url}`,
        },
        content: attributes.content,
        createdAt: getDate(attributes.createdAt),
        readTime: `${readingTime(attributes.content)} min`,
      };
      return {
        article,
        slug: params.slug,
      };
    } catch (e) {
      console.log(e);
    }
  },
  async fetch() {
    const resp = await getCollections(
      `${CONSTANTS.BLOG_API_ENDPOINT}/api/posts?populate=author.avatar,tags,coverImage,category&filters[slug][ne]=${this.slug}&pagination[start]=0&pagination[limit]=5`,
      CONSTANTS.BLOG_API_KEY
    );
    const blogs = [];
    resp.forEach(({ attributes }) => {
      if (attributes.slug === this.slug) return;
      const tags = attributes?.tags.data.map(
        (tag) => tag.attributes.name || []
      );
      const article = {
        title: attributes?.title,
        snippet: attributes?.description,
        slug: attributes?.slug,
        image: `${CONSTANTS.BLOG_API_ENDPOINT}${
          attributes?.coverImage.data?.attributes.formats?.medium?.url ||
          attributes?.coverImage.data?.attributes.formats?.small?.url
        }`,
        category: attributes?.category?.data?.attributes.name,
        tags,
      };
      blogs.push(article);
    });
    this.relatedBlogs = blogs || [];
  },
  data() {
    return {
      relatedBlogs: [],
      share: [],
    };
  },
  head() {
  const url = `https://aibuddha.in/blogs/${this.article.slug}`;
  const title = `${this.article.title} | AiBuddha`;
  return {
    title,
    meta: [
      { hid: 'description', name: 'description', content: this.article.snippet },
      { hid: 'og:title', property: 'og:title', content: title },
      { hid: 'og:description', property: 'og:description', content: this.article.snippet }, // Open Graph description
      { hid: 'og:image', property: 'og:image', content: this.article.image }, // Open Graph image
      { hid: 'og:url', property: 'og:url', content: url },
      { hid: 'twitter:card', name: 'twitter:card', content: 'summary_large_image' },
      { hid: 'twitter:title', name: 'twitter:title', content: title },
      { hid: 'twitter:description', name: 'twitter:description', content: this.article.snippet },
      { hid: 'twitter:image', name: 'twitter:image', content: this.article.image },
      { hid: 'keywords', name: 'keywords', content: `${this.article.tags.join(', ')}, blog, AiBuddha` },
      { hid: 'author', name: 'author', content: this.article.author.name }
    ],
    link: [
      { rel: 'canonical', href: url }
    ],
    openGraph: {
      image: {
        url: this.article.image,
        alt: title,
      },
    },
  };
},
  methods: {
    goBack() {
      const isFromRoot = this.$nuxt.context?.from?.path === "/blogs";
      isFromRoot ? this.$router.go(-1) : this.$router.push("/blogs");
    },
    copyToClipboard() {
      const articleLink = `https://aibuddha.in/blogs/${this.article.slug}`;
      navigator.clipboard.writeText(articleLink);
      this.$toast
        .show("Copied link!", { position: "bottom-center" })
        .goAway(2000);
    },
    shareItems() {
      const articleLink = `https://aibuddha.in/blogs/${this.article.slug}`;
      const shareObj = [
        {
          name: "facebook",
          image: "/images/blog/share/fb.png",
          url: `https://www.facebook.com/sharer/sharer.php?u=${articleLink}`,
        },
        {
          name: "x",
          image: "/images/blog/share/x.png",
          url: `https://twitter.com/intent/tweet?url=${articleLink}&text=${this.article.title}`,
        },
        {
          name: "linkedin",
          image: "/images/blog/share/linkedin.png",
          url: `https://www.linkedin.com/shareArticle?mini=true&url=${articleLink}`,
        },
        {
          name: "email",
          image: "/images/blog/share/email.png",
          url: `mailto:?subject=Hello,\n\n\n\nCheck out this article - ${this.article.title}&amp;body=Here is a nice article I found on Aibuddha \n \n ${articleLink}`,
        },
        {
          name: "link",
          image: "/images/blog/share/link.png",
          url: "",
        },
      ];
      return shareObj;
    },

    handleCopy(e) {
      if (e.target.classList.contains("copy-btn-elem")) {
        const copyBtn = e.target.closest(".copy-btn");
        const code = copyBtn.nextElementSibling.innerText;
        const reset = () => {
          setTimeout(() => {
            copyBtn.children[0].textContent = "copy";
          }, 2000);
        };
        navigator.clipboard.writeText(code).then(
          () => {
            copyBtn.children[0].textContent = "copied";
            reset();
          },
          () => {
            copyBtn.children[0].textContent = "couldn't copy";
            reset();
          }
        );
      }
    },
  },
  beforeMount() {
    this.share = this.shareItems();
  },
};
